"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mui_1 = require("tss-react/mui");
const useStyles = (0, mui_1.makeStyles)()((theme) => {
    const { palette, shadows, spacing, typography, applyOpacityToHex } = theme;
    const tableBg = palette.background.paper;
    const txnBg = palette.background.paper;
    return {
        settingsBar: {
            display: 'flex',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            gap: spacing(3),
            padding: '16px 20px',
            backgroundColor: palette.background.settingsBarBackground,
            borderRadius: 0,
            borderBottom: `1px solid ${palette.border.dark}`,
        },
        menuColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        menuLabel: Object.assign({ marginBottom: 2, paddingLeft: 8 }, typography.caption),
        viewMenuValue: {
            fontSize: 14,
            fontWeight: 400,
        },
        categoryInput: {
            minWidth: 134,
        },
        filtersGroup: {
            paddingTop: 20,
        },
        expandAllGroup: {
            paddingTop: 20,
            paddingLeft: 40,
        },
        spacer: {
            flex: 1,
            minWidth: 40,
        },
        selectionBar: {
            display: 'flex',
            alignItems: 'center',
            gap: spacing(1),
            height: '60px',
            paddingLeft: '20px',
            marginTop: '20px',
            backgroundColor: applyOpacityToHex(palette.text.strong, 0.1),
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
        },
        selectionText: {
            color: palette.primary.main,
            fontWeight: 500,
        },
        tableOuter: {
            marginTop: '20px',
            backgroundColor: palette.background.paper,
            border: `1px solid ${palette.divider}`,
            borderTop: 'none',
            borderRadius: 5,
        },
        tableZeroState: {
            marginTop: '20px',
            backgroundColor: palette.background.paper,
            border: `1px solid ${palette.divider}`,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            width: '100%',
            margin: 'auto',
            height: 'auto',
            minHeight: 225,
            paddingTop: 40,
            position: 'relative',
        },
        tableOuterWithSelection: {
            marginTop: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
        headRow: {
            backgroundColor: palette.background.paper,
            '& > th': {
                borderBottom: `1px solid ${palette.divider}`,
                borderTop: 'none',
            },
        },
        headCell: {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '30px',
            color: palette.text.primary,
            backgroundColor: tableBg,
            borderTop: 'none',
            borderBottom: `1px solid ${palette.divider}`,
            paddingTop: 8,
            paddingBottom: 8,
        },
        headCellFirst: {
            borderTopLeftRadius: 5,
        },
        headCellLast: {
            borderTopRightRadius: 5,
        },
        tableBgCell: {
            backgroundColor: tableBg,
        },
        rowCell: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 1,
        },
        rowCellContent: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 14,
        },
        tagsEditField: {
            '& .MuiInputBase-root': {
                minHeight: 32,
                height: 32,
                alignItems: 'center',
            },
            '& .MuiInputBase-input': {
                paddingTop: 0,
                paddingBottom: 0,
                lineHeight: '32px',
            },
            '& svg': {
                fontSize: 18,
            },
        },
        clrCellContent: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 28,
        },
        zebraRow: {
            '&.odd': {
                backgroundColor: palette.background.paper,
            },
        },
        categoryRow: {
            '& > *': {
                backgroundColor: palette.background.default,
                borderBottom: `1px solid ${palette.divider}`,
                padding: '5px !important',
                maxHeight: 20,
            },
        },
        transactionRow: {
            '& > *': {
                backgroundColor: txnBg,
                borderBottom: `1px solid ${palette.divider}`,
                paddingTop: 6,
                paddingBottom: 6,
            },
        },
        groupHeaderCell: {
            backgroundColor: palette.background.default,
        },
        groupHeaderCellWithTopBorder: {
            borderTop: `1px solid ${palette.divider}`,
        },
        groupHeaderText: {
            color: palette.text.strong,
            fontWeight: 500,
            fontSize: 14,
            letterSpacing: 0.3,
        },
        rowKeyText: {
            color: palette.text.strong,
            fontWeight: 500,
            fontSize: 14,
            letterSpacing: 0.3,
            paddingLeft: 4,
        },
        amountText: {
            color: palette.text.strong,
            fontWeight: 500,
            fontSize: 14,
            letterSpacing: 0.3,
        },
        actionIcon: {
            padding: 6,
        },
        filtersButton: {
            backgroundColor: palette.background.paper,
            boxShadow: shadows[2],
            fontSize: 14,
            fontWeight: 400,
        },
        expandAllButton: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: palette.secondary.main,
            fontSize: 14,
            fontWeight: 500,
            border: `1px solid ${palette.border.dark}`,
            '& .MuiSvgIcon-root': {
                color: palette.text.primary,
            },
            '&:hover': {
                backgroundColor: palette.background.paper,
            },
        },
        downloadButton: {
            padding: 0,
            boxShadow: shadows[2],
            borderRadius: 4,
            overflow: 'hidden',
            border: `1px solid ${palette.border.main}`,
            backgroundColor: palette.background.paper,
            display: 'flex',
            alignItems: 'stretch',
        },
        downloadSegment: {
            borderRadius: 0,
        },
        downloadDivider: {
            width: 1,
            backgroundColor: palette.border.main,
        },
        sortLabel: {
            fontSize: 16,
            fontWeight: 500,
            '& .MuiTableSortLabel-icon': {
                opacity: 1,
            },
        },
        filterNumberIcon: {
            color: palette.secondary.contrastText,
            background: palette.primary.main,
            padding: 5,
            lineHeight: 0.8,
            fontSize: '14px !important',
            borderRadius: 4,
        },
        downloadIcon: {
            marginRight: 5,
        },
        checkboxCompactWrapper: {
            display: 'flex',
            margin: -4,
        },
        clickableText: {
            color: palette.primary.main,
            cursor: 'pointer',
            '&:hover': {
                color: palette.primary.light,
            },
            position: 'relative',
        },
    };
});
exports.default = useStyles;
